import { ABBYCARE_FHIR_STRUCTURE_DEFINITION_BASE, HL7_TERMINOLOGY_CODES_BASE } from 'fhir/constants'

export const CONSENT_SCOPE_CODE_SYSTEM = `${HL7_TERMINOLOGY_CODES_BASE}/consentscope`

export const CONSENT_ACTION_CODE_SYSTEM = `${HL7_TERMINOLOGY_CODES_BASE}/consentaction`
export enum ConsentActionCode {
  EXECUTE_TREATMENT = 'execute-treatment',
  DISCHARGE = 'discharge'
}

export const CONSENT_CATEGORY_CODE_SYSTEM = `${ABBYCARE_FHIR_STRUCTURE_DEFINITION_BASE}/consent-category`
export enum ConsentCategoryCode {
  AUTHORIZATION = 'authorization',
  CERT_PERIOD = 'cert-period',
  CAREPLAN_APPROVAL = 'careplan-approval',
  HOME_HEALTH = 'home-health-care'
}

export const CONSENT_ACTOR_ROLE_CODE_SYSTEM = `${HL7_TERMINOLOGY_CODES_BASE}/provenance-participant-type`
export enum ConsentActorRoleCode {
  AUTHOR = 'author',
  DATA_SUBJECT = 'datasubject',
  PERFORMER = 'performer'
}

export const CONSENT_TYPE_CODE_SYSTEM = `${ABBYCARE_FHIR_STRUCTURE_DEFINITION_BASE}/consent-type`
export enum ConsentTypeCode {
  AUTHORIZATION = 'authorization',
  CERT_PERIOD = 'cert-period',
  CAREPLAN_APPROVAL = 'careplan-approval'
}

export enum ConsentStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
  PROPOSED = 'proposed',
  REJECTED = 'rejected',
  ENTERED_IN_ERROR = 'entered-in-error',
  CANCELLED = 'cancelled'
}

export const ACTIVE_CONSENT_STATUSES = [ConsentStatus.ACTIVE, ConsentStatus.PROPOSED]

export const ALL_CONSENT_STATUSES = [
  ConsentStatus.ACTIVE,
  ConsentStatus.PROPOSED,
  ConsentStatus.CANCELLED,
  ConsentStatus.ENTERED_IN_ERROR,
  ConsentStatus.INACTIVE,
  ConsentStatus.REJECTED
]

export const NON_DELETED_CONSENT_STATUSES = [
  ConsentStatus.ACTIVE,
  ConsentStatus.PROPOSED,
  ConsentStatus.CANCELLED
]

export enum ProvisionType {
  PERMIT = 'permit',
  DENY = 'deny'
}

export const CONSENT_EPISODE_OF_CARE_EXTENSION_URL = `${ABBYCARE_FHIR_STRUCTURE_DEFINITION_BASE}/consent-episode-of-care`
export const CONSENT_CAREPLAN_EXTENSION_URL = `${ABBYCARE_FHIR_STRUCTURE_DEFINITION_BASE}/consent-careplan`
export const CONSENT_CARE_HOURS_EXTENSION_URL = `${ABBYCARE_FHIR_STRUCTURE_DEFINITION_BASE}/consent-care-hours`

export const CONSENT_CHARTING_CATEGORY_EXTENSION_URL = `${ABBYCARE_FHIR_STRUCTURE_DEFINITION_BASE}/consent-charting-category`
export const CONSENT_FLEXIBLE_SCHEDULE_EXTENSION_URL = `${ABBYCARE_FHIR_STRUCTURE_DEFINITION_BASE}/consent-flexible-schedule`
export const CONSENT_LOCATION_CODE_EXTENSION_URL = `${ABBYCARE_FHIR_STRUCTURE_DEFINITION_BASE}/consent-location-code`
export const CONSENT_SERVICE_REQUEST_EXTENSION_URL = `${ABBYCARE_FHIR_STRUCTURE_DEFINITION_BASE}/consent-service-request`

// This set of enums is shared across the consent and service request resources
export enum ConsentChartingCategory {
  STANDARD_SHIFT = 'standard-shift',
  VISIT = 'visit'
}
